import React, { useState, useEffect, useContext } from 'react'
import { withRouter } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import { Row, Col, Container } from 'reactstrap'
import { isEmpty, concat, remove } from 'lodash'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import ProductCard from '../../components/Common/ProductCard'
import Breadcrumbs from '../../components/Common/Breadcrumb'
import Filters from '../../components/Common/Filters'
import ApiService from '../../data/services/ApiService'
import { GeneralContext } from '../../context/'
import { getImagesOfProduct } from '../../helpers/utils'

const LIMIT = 15

const Index = (props) => {
    const generalContext = useContext(GeneralContext)
    const { setLoading } = generalContext
    const { slug } = useParams()
    const [catalog, setCatalog] = useState()
    const [products, setProducts] = useState([])
    const [offset, setOffset] = useState(0)
    const [page, setPage] = useState(1)

    const [families, setFamilies] = useState([])
    const [filterFamilies, setFilterFamilies] = useState([])
    const [categories, setCategories] = useState([])
    const [filterCategories, setFilterCategories] = useState([])
    const [subcategories, setSubcategories] = useState([])
    const [filterSubcategories, setFilterSubcategories] = useState([])
    const [minPrice, setMinPrice] = useState(0)
    const [maxPrice, setMaxPrice] = useState(0)
    const [filterPrice, setFilterPrice] = useState([])

    async function getFamiliesBySlug() {
        try {
            setLoading(true)
            const response = await ApiService.getFamiliesBySlug(slug)
            setFamilies(response.data.data)
        } catch(e) {
            if (e.response) {
                toastr.error(`${e.response.data.message}`, 'Error')
            } else {
                toastr.error(`${e}`, 'Error')
            }
        } finally {
            setLoading(false)
        }
    }

    async function getRangePriceBySlug() {
        try {
            setLoading(true)
            const response = await ApiService.getRangePriceBySlug(slug)
            if (!isEmpty(response.data)) {
                setMinPrice(parseInt(response.data.minPrice.wholeSalePrice))
                setMaxPrice(parseInt(response.data.maxPrice.wholeSalePrice))
            }
        } catch(e) {
            if (e.response) {
                toastr.error(`${e.response.data.message}`, 'Error')
            } else {
                toastr.error(`${e}`, 'Error')
            }
        } finally {
            setLoading(false)
        }
    }

    async function getCategoriesBySlug() {
        try {
            setLoading(true)
            const response = await ApiService.getCategoriesBySlug(slug, filterFamilies)
            setCategories(response.data.data)
        } catch(e) {
            if (e.response) {
                toastr.error(`${e.response.data.message}`, 'Error')
            } else {
                toastr.error(`${e}`, 'Error')
            }
        } finally {
            setLoading(false)
        }
    }

    async function getSubcategoriesBySlug() {
        try {
            setLoading(true)
            const response = await ApiService.getSubcategoriesBySlug(slug, filterFamilies, filterCategories)
            setSubcategories(response.data.data)
        } catch(e) {
            if (e.response) {
                toastr.error(`${e.response.data.message}`, 'Error')
            } else {
                toastr.error(`${e}`, 'Error')
            }
        } finally {
            setLoading(false)
        }
    }

    async function fetchProductsBySlug() {
        try {
            setLoading(true)
            const response =
                await ApiService.getProductsBySlug(
                    slug,
                    offset,
                    LIMIT,
                    filterFamilies,
                    filterCategories,
                    filterSubcategories,
                    filterPrice
                )
            setCatalog(response.data.catalog)
            const { products: productsResponse } = response.data
            if (!isEmpty(products)) {
                const moreProducts = concat(products, productsResponse)
                setProducts(moreProducts)
            } else {
                setProducts(productsResponse)
            }
        } catch(e) {
            if (e.response) {
                toastr.error(`${e.response.data.message}`, 'Error')
            } else {
                toastr.error(`${e}`, 'Error')
            }
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        (async function fetch() {
            await getRangePriceBySlug()
        })()
    }, []) // eslint-disable-line

    useEffect(() => {
        (async function fetch() {
            await getFamiliesBySlug()
        })()
    }, []) // eslint-disable-line

    useEffect(() => {
        (async function fetch() {
            await getCategoriesBySlug()
        })()
    }, [filterFamilies]) // eslint-disable-line

    useEffect(() => {
        (async function fetch() {
            await getSubcategoriesBySlug()
        })()
    }, [filterFamilies, filterCategories]) // eslint-disable-line

    useEffect(() => {
        (async function fetch() {
            await fetchProductsBySlug()
        })()
    }, [offset, filterFamilies, filterCategories, filterSubcategories, filterPrice]) // eslint-disable-line

    const moreProducts = async () => {
        setPage(page + 1)
        setOffset(page * LIMIT)
    }

    const shareProduct = async (product) => {
        const productPublicUrl = `https://mitiendasocial.com/producto/`
        const shareText = `Este%20producto%20te%20va%20a%20encantar%20%F0%9F%A4%A9%F0%9F%A4%A9%20`
        window.open(`https://api.whatsapp.com/send?text=${shareText}${productPublicUrl}${product.supplierCode}`)
    }

    const itemAction = (product) => {
        props.history.push(`/catalogos/detalles/${slug}/productos/${product.id}`)
    }

    const addToCart = () => {
        console.log('addToCart')
    }

    const familyChecked = (event, value) => {
        setProducts([])
        setPage(1)
        setOffset(0)
        if (event.target.checked) {
            const filter = filterFamilies
            filter.push(value.id)
            setFilterFamilies([...filter])
        } else {
            const filter = filterFamilies
            remove(filter, n => n === value.id)
            setFilterFamilies([...filter])
        }
    }

    const categoryChecked = (event, value) => {
        setProducts([])
        setPage(1)
        setOffset(0)
        if (event.target.checked) {
            const filter = filterCategories
            filter.push(value.id)
            setFilterCategories([...filter])
        } else {
            const filter = filterCategories
            remove(filter, n => n === value.id)
            setFilterCategories([...filter])
        }
    }

    const subcategoryChecked = (event, value) => {
        setProducts([])
        setPage(1)
        setOffset(0)
        if (event.target.checked) {
            const filter = filterSubcategories
            filter.push(value.id)
            setFilterSubcategories([...filter])
        } else {
            const filter = filterSubcategories
            remove(filter, n => n === value.id)
            setFilterSubcategories([...filter])
        }
    }

    const setPriceRange = (range) => {
        setProducts([])
        setPage(1)
        setOffset(0)
        setFilterPrice(range)
    }

    return(
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs
                        title="Catálogos"
                        breadcrumbItem={catalog ? catalog.name : ''}
                        parentLink={`/catalogos`}
                    />
                    <Row>
                        <Col sm="2">
                            <Filters
                                minPrice={minPrice}
                                maxPrice={maxPrice}
                                setPriceRange={setPriceRange}
                                showSuppliers={false}
                                families={families}
                                familyChecked={familyChecked}
                                categories={categories}
                                categoryChecked={categoryChecked}
                                subcategories={subcategories}
                                subcategoryChecked={subcategoryChecked}
                                showBrands={false}
                            />
                        </Col>
                        <Col>
                            <Row>
                                {!isEmpty(products) && products.map(
                                    (item, key) => (
                                        <Col key={key} sm={4} style={{ textAlign: 'center', marginBottom: '15px' }}>
                                            <ProductCard
                                                photos={getImagesOfProduct(item.gallery)}
                                                code={`${item.supplierCode ? `Código ${item.supplierCode}` : ''}`}
                                                price={`${item.wholeSalePrice || 0}`}
                                                productName={item.name}
                                                showVariants={false}
                                                showFooterOptions
                                                shareButtonText='Compartir'
                                                shareButtonAction={() => shareProduct(item)}
                                                addToCartButtonText='Agregar al carrito'
                                                addToCartButtonAction={() => addToCart(item)}
                                                itemAction={() => itemAction(item)}
                                            />
                                        </Col>
                                    )
                                )}
                            </Row>
                            {!isEmpty(products) && (
                                <div className="text-center" style={{ padding: '32px 0' }}>
                                    <button
                                        onClick={ moreProducts } 
                                        className={`btn btn-secondary`}
                                    >
                                        Ver más productos
                                    </button>
                                </div>
                            )}
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(Index)
